import { HttpClient } from '@angular/common/http';
import { type EnvironmentProviders, TransferState } from '@angular/core';
import { SvgLoader, provideAngularSvgIcon } from 'angular-svg-icon';

import { SvgBrowserLoader } from './svg-loader.browser';

/**
 * Провайдер `angular-svg-icon` для браузера: грузит SVG по HTTP, с подхватом
 * из `TransferState` (см. [[SvgBrowserLoader]]). Прячет обвязку
 * `provideAngularSvgIcon({ loader: { ... } })` из `app.config.browser.ts`.
 */
export function provideSvgBrowserLoader(): EnvironmentProviders {
  return provideAngularSvgIcon({
    loader: {
      deps: [HttpClient, TransferState],
      provide: SvgLoader,
      useFactory: (http: HttpClient, transferState: TransferState) =>
        new SvgBrowserLoader(http, transferState),
    },
  });
}
